import type { HTMLAttributes } from 'react';

export type BdiProps = HTMLAttributes<HTMLElement>;

/** Isoliert gemischte Zahlen-/Text-Snippets von der umgebenden Schreibrichtung. */
export function Bdi({ children, ...props }: BdiProps) {
  return <bdi {...props}>{children}</bdi>;
}
